/**
 * @Copyright (c) 2021 DigiNet
 * @author NHATLONG
 * @create 27/7/2021
 * @Example
 */

import React, { useState, useEffect, useRef, useCallback } from 'react';
import ActionToolbar from '../../../common/toolbar/action-toolbar';
import { LoadPanel } from "devextreme-react";
import { browserHistory } from 'react-router';
import Config from '../../../../config/index';
import { Button, TabContainer, TabHeader, TabItem, TabPanel } from 'diginet-core-ui/components';
import TabGeneral from './W06F0009TabGeneral';
import TabInventory from './W06F0009TabInventory';
import { makeStyles } from '@material-ui/core/styles';
import * as W06F0009Actions from '../../../../redux/W0X/W06F0009/W06F0009_actions';
import * as generalActions from '../../../../redux/general/general_actions';
import { useDispatch } from 'react-redux';

const useStyles = makeStyles((theme) => ({
    textInfo: {
        // color: theme.palette.primary.main,
        // fontSize: 16,
        // fontWeight: 600
    },
    TabContainer: {
        '& .DGN-UI-Accordion': {
            '&:not(:first-child)': {
                marginTop: 10
            }
        },
        '& .Tab-Container .tab-panel > :first-of-type': {
            width: '100%'
        }
    },
    subTitle: {
        color: '#7F828E'
    },
    diff: {
        '& input': {
            color: 'red !important'
        }
    }
}));


const W05F0009 = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [tab, setTab] = useState(0);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState(null);
    const [decimalQuantity, SetDecimalQuantity] = useState(null);
    const ExchangeRate = useRef(1);

    const refTabGeneral = useRef(null);
    const refTabInventory = useRef(null);

    const [isUpdated, setIsUpdated] = useState(false);

    const [permission, setPermission] = useState(0);

    const getInfo = (flag) => {
        const { location } = props;
        if (location && location.state) {
            return {
                ContractID: location.state.ContractID,
                ContractNo: location.state.ContractNo,
                SubContractID: location.state.SubContractID,
                mode: location.state.mode,
            }
        } else {
            if (flag) {
                browserHistory.push(Config.getRootPath() + "W06F0008");
                return null;
            }
            return false;
        }
    };

    const loadPermission = (formID) => {
        dispatch(generalActions.getPermission("W06F0008", (isPer) => {
            if (isPer) {
                setPermission(isPer);
            }
        }))
    };

    useEffect(() => {
        if (!getInfo(true)) return;
        loadPermission();
        const { mode } = getInfo();
        if (mode !== 'view') {
            Config.checkRedirect(props.location.pathname);
        }
        return () => {
            if (mode !== 'view') {
                Config.unCheckRedirect();
            }
        }
        /* eslint-disable */
    }, [])

    useEffect(() => {
        if (permission >= 2) {
            const { mode } = getInfo();
            loadForm(mode);
        }
        /* eslint-disable */
    }, [permission])

    const loadForm = (_mode) => {
        const params = {
            Language: Config.language || 84,
            // DataType: _mode === 'add' ? 'FormAddNew' : 'FormEdit',
            ContractID: ContractID,
            SubContractID: SubContractID
        };
        setLoading(true);
        dispatch(W06F0009Actions[_mode === 'add' ? 'loadFormAddNew' : 'loadFormEdit'](params, (error, data) => {
            if (error) {
                let message = error.message || Config.lang("Loi_chua_xac_dinh");
                Config.popup.show("danger", message);
                setLoading(false);
                return false;
            }
            setFormData(data);
            ExchangeRate.current = data.master?.ExchangeRate;
            getDecimalQuantity(data.master?.CurrencyID);
        }));
    }

    const getDecimalQuantity = (CurrencyID) => {
        dispatch(W06F0009Actions.getDecimalQuantity({ CurrencyID }, (error, data) => {
            if (error) {
                let message = error.message || Config.lang("Loi_chua_xac_dinh");
                Config.popup.show("danger", message);
                setLoading(false);
                return false;
            }
            setLoading(false);
            SetDecimalQuantity(data);
        }));
    }

    const numberFormat = (number, limitNumber = 0) => {
        const formatter = new Intl.NumberFormat("en-US", {
            minimumFractionDigits: limitNumber,
            maximumFractionDigits: limitNumber,
        });
        const _number = formatter.format(String(number));
        return !_number || _number === "NaN" ? 0 : _number;
    };

    const countDecimals = (value) => {
        if (Math.floor(value) === value) return 0;
        return value.toString().split(".")[1].length || 0;
    }

    const cellRenderNumber = (e, decimal) => {
        if (Config.isEmpty(e.displayValue) && e.displayValue !== 0) return null;
        return numberFormat(e.displayValue, decimal ?? countDecimals(e.displayValue));
    }

    const onChangeTab = (isTab) => {
        setTab(isTab);
    }

    const checkSubContractNo = (SubContractID, SubContractNo) => {
        const params = {
            SubContractID: SubContractID,
            SubContractNo: SubContractNo
        }
        dispatch(W06F0009Actions.checkSubContractNo(params, (error, data) => {
            if (error) {
                let message = error.message || Config.lang("Loi_chua_xac_dinh");
                Config.popup.show("DANGER", message);
                return false;
            }
            if (data.Status) {
                Config.popup.show("INFO", data.Message);
            }
        }));
    }

    const onSave = async () => {
        const master = await refTabGeneral.current.onSave();
        if (!master) {
            setTab(0); return;
        }
        const commodity = await refTabInventory.current.onSave();
        master.ContractID = ContractID;
        master.SubContractID = SubContractID;
        const params = {
            ContractID,
            SubContractID,
            master,
            commodity,
            attachments: master.attachment
        };
        dispatch(W06F0009Actions[mode === 'add' ? 'onSave' : 'onEdit'](params, (error, data) => {
            if (error) {
                let message = error.message || Config.lang("Loi_chua_xac_dinh");
                Config.popup.show("DANGER", message);
                return false;
            }
            if (data.Status) {
                Config.popup.show("INFO", data.Message);
                return false;
            }
            checkSubContractNo(mode === 'add' ? data.SubContractID : SubContractID, master.SubContractNo);
            saveHistory(mode === 'add' ? data.SubContractID : SubContractID);
        }));
    }

    const saveHistory = async (SubID) => {
        let dataHistory = [];
        const dataMaster = refTabGeneral.current.onCreateSaveHistory(SubID);
        dataHistory = dataHistory.concat(dataMaster);
        const dataInventory = await refTabInventory.current.onCreateSaveHistory(SubID);
        dataHistory = dataHistory.concat(dataInventory);
        const params = {
            attributes: JSON.stringify(dataHistory),
        };
        await Config.saveHistory(params, async (er, data) => {
            if (data) {
                Config.notify.show("success", Config.lang("Luu_thanh_cong"), 2000);
            } else {
                Config.notify.show("error", Config.lang("Loi"), 2000);
            }
            await Config.unCheckRedirect();
            browserHistory.push({
                pathname: Config.getRootPath() + 'W06F0010',
                state: {
                    ContractID: ContractID,
                    SubContractID: SubID,
                    ContractNo: ContractNo,
                    mode: 'view'
                }
            });
        });
    }

    const onSetIsUpdate = useCallback(() => {
        setIsUpdated(true);
    }, [])

    const goBack = () => {
        if (isUpdated) {
            Config.popup.show("YES_NO", Config.lang("Du_lieu_chua_duoc_luu_ban_co_muon_tiep_tuc_khong"), () => {
                browserHistory.goBack();
            });
        } else {
            browserHistory.goBack();
        }
    }

    if (!getInfo() || permission < 2) return null;
    const { ContractNo, ContractID, SubContractID, mode } = getInfo();
    return (
        <div className={classes.TabContainer}>
            <ActionToolbar allwaysTop title={Config.lang("Chi_tiet_phu_luc_hop_dong_mua")} onBack={goBack}>
                <div className="display_row align-center align-between full_w">
                    <Button viewType="filled" startIcon="saveV2" color='info' label={Config.lang("Luu")} onClick={onSave}
                        disabled={!isUpdated} />
                    <span className={classes.subTitle}>{Config.lang('Phu_luc_hop_dong')}: {ContractNo}</span>
                </div>
            </ActionToolbar>
            <LoadPanel
                shadingColor="rgba(0,0,0,0.4)"
                position={{ my: 'center', of: "root" }}
                visible={loading}
                showIndicator={true}
                shading={true}
                showPane={true}
            />
            <TabContainer
                tabIndex={tab}
            >
                <TabHeader
                    style={{
                        justifyContent: 'space-between'
                    }}
                >
                    <TabItem
                        index={0}
                        onClick={() => onChangeTab(0)}
                        label={Config.lang("Thong_tin_phu_luc")}
                    />
                    <TabItem
                        index={1}
                        onClick={() => onChangeTab(1)}
                        label={Config.lang("Hang_hoa")}
                    />
                </TabHeader>
                <TabPanel index={0}>
                    <TabGeneral
                        ref={ref => refTabGeneral.current = ref}
                        classes={classes} formData={formData?.master}
                        decimalQuantity={decimalQuantity} mode={mode}
                        attachments={formData?.attachments ?? []}
                        onSetIsUpdate={onSetIsUpdate}
                        ContractID={ContractID}
                    />
                </TabPanel>
                <TabPanel index={1}>
                    <TabInventory
                        ref={ref => refTabInventory.current = ref}
                        formData={formData?.commodity} decimalQuantity={decimalQuantity}
                        ExchangeRate={ExchangeRate.current} numberFormat={numberFormat} cellRenderNumber={cellRenderNumber}
                        mode={mode} onSetIsUpdate={onSetIsUpdate}
                        TransTypeID={formData?.master?.TransTypeID}
                        CurrencyID={formData?.master?.CurrencyID}
                    />
                </TabPanel>
            </TabContainer>
        </div>
    );
};

export default W05F0009;